<nz-tag class="{{ type() }}"><ng-content /></nz-tag>
